module.exports = __webpack_public_path__ + "static/media/people.7be41f92.jpg";